import React from 'react';
import './ProjectContextMenu.css';
import {Card, ClickAwayListener} from "@mui/material";
import Box from "@mui/material/Box";
import {DeleteIcon, RenameIcon} from "./HomeIcons";
import {MicOutlined} from "@mui/icons-material";
import RecordWithOthers from "../../assets/RecordWithOthers";
import RecordWithOthersIcon from "../../assets/RecordWithOthers";
import RecordScreenIcon, {RecordAudioOnlyIcon} from "../../assets/RecordScreen";
import RecordCameraIcon from "../../assets/RecordCamera";

const NewProjectContextMenu = ({top, left, onRename, onDelete, onClose}) => {
    return (
        <ClickAwayListener onClickAway={onClose}>
            <div
                className="project-context-menu"
                style={{top: `${top}px`, left: `${left}px`, position: 'absolute', zIndex: 9999}}
                onMouseLeave={onClose}
            >
                <button onClick={onRename}>
                    ✏️ Rename project
                </button>
                <button onClick={onDelete} className="danger">
                    🗑️ Delete project
                </button>
            </div>
        </ClickAwayListener>
    );
};

export const RecordSomethingMenu = ({
                                        setOpen,
                                        top,
                                        left,
                                        handleRecordAudioOnlyClick,
                                        handleRecordScreenClick,
                                        handleRecordCameraClick,
                                        handleRecordWithOthersClick,
                                        disableRecordWithOthers = false,
                                    }) => {
    const boxStyle = {
        position: "absolute",
        top: `${top}px`,
        left: `${left}px`,
        display: "inline-flex",
        padding: "8px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        width: "min(260px, calc(100vw - 16px))",
        gap: "4px",
        borderRadius: "12px",
        background: "var(--app-bg-surface)",
        border: "1px solid var(--app-border-subtle)",
        boxShadow: "0px 20px 60px rgba(15, 23, 42, 0.08)",
        zIndex: 1000,
    }

    const itemStyle = {
        display: "flex",
        padding: "8px",
        alignItems: "center",
        gap: "8px",
        alignSelf: "stretch",
        cursor: "pointer",
        borderRadius: "8px",
        // On hover
        '&:hover': {
            background: "var(--app-bg-subtle)",
        },
    }
    
    const itemStyleWithDisabled = (disabled) => {
        if (!disabled) return itemStyle;
        return {
            ...itemStyle,
            opacity: 0.55,
            cursor: "not-allowed",
            '&:hover': {
                background: "transparent",
            },
        };
    };

    const itemTextStyle = {
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "0.14px",
        color: "var(--app-text-primary)",
    }

    const dividerStyle = {
        alignSelf: "stretch",
        height: "1px",
        backgroundColor: "var(--app-border-subtle)",
        margin: "4px 8px",
    }

    return (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
            <Card style={boxStyle}>
                <Box sx={itemStyle} onClick={handleRecordCameraClick}>
                    <Box style={{display: "flex"}}>
                        <RecordCameraIcon/>
                    </Box>
                    <Box style={itemTextStyle}>
                        Camera
                    </Box>
                </Box>
                <Box sx={itemStyle} onClick={handleRecordScreenClick}>
                    <Box style={{display: "flex"}}>
                        <RecordScreenIcon/>
                    </Box>
                    <Box style={itemTextStyle}>
                        Screen
                    </Box>
                </Box>
                <Box sx={itemStyle} onClick={handleRecordAudioOnlyClick}>
                    <Box style={{display: "flex",}}>
                        <RecordAudioOnlyIcon/>
                    </Box>
                    <Box style={itemTextStyle}>
                        Audio only
                    </Box>
                </Box>
                <Box sx={dividerStyle} />
                <Box
                    sx={itemStyleWithDisabled(disableRecordWithOthers)}
                    onClick={disableRecordWithOthers ? undefined : handleRecordWithOthersClick}
                >
                    <Box style={{display: "flex"}}>
                        <RecordWithOthersIcon/>
                    </Box>
                    <Box style={itemTextStyle}>
                        Record with others
                    </Box>
                </Box>
            </Card>
        </ClickAwayListener>
    )
}

export default NewProjectContextMenu;
